import { Cookie } from './cookie';

declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window {
        MSPointerEvent: typeof window.PointerEvent | undefined;
    }
}

/**
 * Private window IE11
 */
const isIE11 =
    !window.indexedDB && (window.PointerEvent || window.MSPointerEvent);

/**
 * @class
 * Storage class is a wrapper around the browser's localStorage API or browser's cookie
 * If the user is on IE11 we default to Cookies else we use the localStorage API
 */
export class Storage {
    /**
     * Returns the item stored in the browser's localStorage/cookie by name or null
     *
     * @param {string} name - the name used to store the item
     *
     * @return {string | null}
     */
    static getItem(name: string): string | null {
        if (isIE11) {
            return Cookie.get(name);
        }
        return window.localStorage.getItem(name);
    }

    /**
     * Stores the value with the name in the localStorage/cookie
     *
     * @param {string} name - the name to use when storing the item
     * @param {string} value - the item to be stored
     *
     * @return {void}
     */
    static setItem(name: string, value: string): void {
        if (isIE11) {
            Cookie.set(name, value, 9999);
        } else {
            window.localStorage.setItem(name, value);
        }
    }

    /**
     * Removes an item with the name from the localStorage/cookie
     *
     * @param {string} name - the name used to store the item
     *
     * @return {void}
     */
    static removeItem(name: string): void {
        if (isIE11) {
            Cookie.remove(name);
        } else {
            window.localStorage.removeItem(name);
        }
    }

    /**
     * Clears all items stored in the localStorage/cookie
     *
     * @return {void}
     */
    static clear(): void {
        if (!isIE11) window.localStorage.clear();
        Cookie.removeAll();
    }
}

export { Cookie };
export { JWT } from './jwt';
